export function getDifficultyClasses(difficulty) {
  //TODO add more when needed
  const difficultyColors = {
    'Moderate & accessible': '#EF722C',
  }

  return difficultyColors[difficulty] || '#000000'
}
